module.exports = __webpack_public_path__ + "static/img/service.17a132c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/service.png
// module id = mlLh
// module chunks = 1